/**
 * JS for Document Manager Functionality
 *
 * Localized vars available as vtcDmVars.
 */
(function ($, window, videojs) {

	function equalizePlaylistHeight() {
		$('.vjs-playlist').each(function () {
			var $this = $(this);

			if (window.innerWidth > 767) {
				// Use the height of the video.
				var videoHeight = $this.prev('.video-js').find('.vjs-poster').height();
			} else {
				// Just set the height to auto, because the playlist will be displayed under the video for resolutions < 768;
				var videoHeight = 'auto';
			}

			$this.height(videoHeight);
		});
	}

	function sortPlaylistCompare(a, b) {
		if (a.order < b.order) {
			return -1;
		}
		if (a.order > b.order) {
			return 1;
		}
		return 0;
	}

	// Listen for instance of each playlist passed through vtcYtVars
	vtcYtVars.forEach(function (playlistData) {
		const videoPlaylist = playlistData.playlistID;
		const videos = playlistData.playlistVideos.data.videoUrls;
		const ytRegex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;
		const playlistID = 'vtc-playlist-' + videoPlaylist;
		const playlistClass = 'vjs-playlist-' + videoPlaylist;

		var playlist = [];
		var ajaxCalls = [];

		if (videos !== null) {
			videos.forEach(function (video) {
				ajaxCalls.push(
					$.getJSON('https://noembed.com/embed',
						{
							format: 'json',
							url: video.url
						},
						function (data) {
							if (video.title !== '') {
								data.title = video.title;
							}
							videoData = {
								name: data.title,
								sources: [{
									src: video.url,
									type: 'video/youtube'
								}],
								poster: data.thumbnail_url,
								order: video.order
							};
							playlist.push(videoData);
						})
				);
			});
		}

		if (videos !== null) {
			$.when.apply($, ajaxCalls).done(function () {
				// After all the videos data has been retrieved, initialize the video and playlist.
				var player = window.player = videojs(playlistID, {
					preload: true,
					techOrder: ['youtube', 'html5'],
					controls: true,
					plugins: {
						videoJsResolutionSwitcher: {
							default: 'high', // Default resolution [{Number}, 'low', 'high'],
							dynamicLabel: true,
						},
					},
				}).ready(() => {
					// Equalize the playlist height with the video height when the video finished loading.
					equalizePlaylistHeight();
				});
				playlist.sort(sortPlaylistCompare);
				player.playlist(playlist);
				player.playlistUi({
					className: playlistClass,
				});
			});

			$(window).resize(function () {
				// Equalize the playlist height whenever the window is resized.
				equalizePlaylistHeight();
			});
		} else {
			$('.product-vct-playlist').remove();
		}
	});

}(jQuery, window, window.videojs));
